import React, { useContext } from 'react';
import { Spacer } from '@chakra-ui/layout';
import { Button, Flex, IconButton, Tooltip, Divider, Text } from '@chakra-ui/react';
import { MdDevices, MdFace, MdHome, MdOutlineArrowCircleLeft, MdOutlineArrowCircleRight } from 'react-icons/md';
import SharedExperienceIcon from './icons/sharedExperienceIcon';
import { MenuContext } from '../lib/menuContext';
import { Link } from 'react-router-dom';
import { UserOrganisationContext } from '../organisation/lib/userOrganisationContext';
import { OrganisationContext } from '../organisation/lib/organisationContext';
import OrganisationLogo from '../organisation/component/organisationLogo';
import useTranslation from '../lib/i18n/useTranslation';
export default function SideMenu() {
  const menuContext = useContext(MenuContext)
  const userOrganisationContext = useContext(UserOrganisationContext)
  const organisationContext = useContext(OrganisationContext)
  const isCollapsed = menuContext.isCollapsed;
  const { t } = useTranslation();

  const getSharedExperiencesLabel = () => {
    if (!isCollapsed) {
      return t('nav.sharedExperiences');
    }

    return (
      <Text textAlign="center" whiteSpace="pre-line" lineHeight="shorter" fontSize="11px">
        {t('nav.sharedExperiences').replace(' ', '\n')}
      </Text>
    );
  };

  return (
    <Flex
      w={isCollapsed ? 88 : 245}
      flexShrink={0}
      borderRight="1px"
      borderColor="divider.grey"
      backgroundColor="white"
      flexDirection={'column'}
      py={3}
      px={isCollapsed ? 2 : 3}
      gap={2}
    >
      <Flex
        flexDirection={"column"}
        gap={2}
        alignItems={"stretch"}
      >
        <Link to="/"  >
          <Button
            boxSizing='borderBox'
            display="flex"
            flexDirection={isCollapsed ? "column" : "row"}
            gap={isCollapsed ? 1 : 0}
            leftIcon={isCollapsed ? undefined : <MdHome size={'15px'} />}
            justifyContent={isCollapsed ? 'center' : 'start'}
            height="auto"
            minH={isCollapsed ? "60px" : "auto"}
            w={'100%'}
            px={isCollapsed ? 2 : 3}
            py={2}
            variant={
              (window.location.href.includes('/home') ? 'coralOutline' : 'greyTransparent')
            }
          >
            {isCollapsed && <MdHome size={'15px'} />}
            <Text textAlign="center" lineHeight="shorter" fontSize={isCollapsed ? "11px" : "inherit"}>
              {t('nav.home')}
            </Text>
          </Button>
        </Link>
        <Link to="/persona">
          <Button
            leftIcon={isCollapsed ? undefined : <MdFace size={'15px'} />}
            boxSizing='borderBox'
            display="flex"
            flexDirection={isCollapsed ? "column" : "row"}
            gap={isCollapsed ? 1 : 0}
            justifyContent={isCollapsed ? 'center' : 'start'}
            height="auto"
            minH={isCollapsed ? "60px" : "auto"}
            w={'100%'}
            px={isCollapsed ? 2 : 3}
            py={2}
            variant={
              (window.location.href.includes('/persona') ? 'blueOutline' : 'greyTransparent')
            }
          >
            {isCollapsed && <MdFace size={'15px'} />}
            <Text textAlign="center" lineHeight="shorter" fontSize={isCollapsed ? "11px" : "inherit"}>
              {t('nav.personas')}
            </Text>
          </Button>
        </Link>
        <Link to="/products">
          <Button
            leftIcon={isCollapsed ? undefined : <MdDevices size={'15px'} />}
            boxSizing='borderBox'
            display="flex"
            flexDirection={isCollapsed ? "column" : "row"}
            gap={isCollapsed ? 1 : 0}
            justifyContent={isCollapsed ? 'center' : 'start'}
            height="auto"
            minH={isCollapsed ? "60px" : "auto"}
            w={'100%'}
            px={isCollapsed ? 2 : 3}
            py={2}
            variant={
              (window.location.href.includes('/products') ? 'purpleOutline' : 'greyTransparent')
            }
          >
            {isCollapsed && <MdDevices size={'15px'} />}
            <Text textAlign="center" lineHeight="shorter" fontSize={isCollapsed ? "11px" : "inherit"}>
              {t('nav.products')}
            </Text>
          </Button>
        </Link>
        <Link to="/shared-experiences">
          <Button
            leftIcon={isCollapsed ? undefined : <SharedExperienceIcon size={'15px'} />}
            boxSizing='borderBox'
            display="flex"
            flexDirection={isCollapsed ? "column" : "row"}
            gap={isCollapsed ? 1 : 0}
            justifyContent={isCollapsed ? 'center' : 'start'}
            height="auto"
            minH={isCollapsed ? "72px" : "auto"}
            w={'100%'}
            px={isCollapsed ? 2 : 3}
            py={2}
            variant={
              (window.location.href.includes('/shared-experiences') ? 'greenOutline' : 'greyTransparent')
            }
          >
            {isCollapsed && <SharedExperienceIcon size={'15px'} />}
            {getSharedExperiencesLabel()}
          </Button>
        </Link>
      </Flex>
      {(userOrganisationContext.hasOrganisation
        || userOrganisationContext.hasPotentialOrganisation)
      && (
        <>
          <Divider />
          <Flex
            gap={2}
            width={"100%"}
            flexDirection={"column"}
            alignItems={"stretch"}
          >
            <Link to="/organisation">
              <Button
                leftIcon={isCollapsed ? undefined : <OrganisationLogo size={25} />}
                boxSizing='borderBox'
                display="flex"
                flexDirection={isCollapsed ? "column" : "row"}
                gap={isCollapsed ? 1 : 0}
                justifyContent={isCollapsed ? 'center' : 'start'}
                height="auto"
                minH={isCollapsed ? "60px" : "auto"}
                w={'100%'}
                px={isCollapsed ? 2 : 3}
                py={2}
                variant={
                  (window.location.href.includes('/organisation') ? 'greyOutline' : 'greyTransparent')
                }
              >
                {isCollapsed && <OrganisationLogo size={25} />}
                {!isCollapsed && (
                  <Text
                    textOverflow="ellipsis"
                    overflow={"hidden"}
                  >
                    {organisationContext?.organisation?.name}
                  </Text>
                )}
              </Button>
            </Link>
          </Flex>
        </>
      )}
      <Spacer />
      <Tooltip label={isCollapsed ? t('nav.openMenu') : t('nav.hideMenu')} >
        <Flex justifyContent={isCollapsed ? "center" : "flex-start"}>
          <IconButton
            variant="greyTransparent"
            fontSize='20px'
            color="text.medium.grey"
            icon={isCollapsed ? <MdOutlineArrowCircleRight /> : <MdOutlineArrowCircleLeft />}
            onClick={menuContext.toggleCollapse}
          />
        </Flex>
      </Tooltip>
    </Flex>
  );
}
